"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DropdownStyled_1 = __importDefault(require("./DropdownStyled"));
const Message_1 = require("../message/Message");
const PosaRedeemActions_1 = __importDefault(require("../../actions/PosaRedeemActions"));
const react_1 = __importDefault(require("react"));
const Tooltip_1 = __importDefault(require("./Tooltip"));
const classnames_1 = __importDefault(require("classnames"));
const callback = ({ value }) => PosaRedeemActions_1.default.setPsnCountry(value);
const RedeemSectionPsnCountryDropDown = ({ psnCountry, psnToolTip, countries }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "redeem-next next-select-platform" },
            react_1.default.createElement("strong", null,
                Message_1.localizedMessage('epic.code.redemption.posa.page.common.next'),
                ":"),
            react_1.default.createElement("span", null, Message_1.localizedMessage('epic.code.redemption.posa.page.redeem.psn.next'))),
        react_1.default.createElement("div", { className: classnames_1.default('input-wrapper psnCountryInput', { verified: psnCountry }) },
            react_1.default.createElement(DropdownStyled_1.default, { placeholder: Message_1.localizedMessage('epic.code.redemption.posa.page.redeem.country'), options: countries, callback: callback }),
            react_1.default.createElement(Tooltip_1.default, { content: psnToolTip }))));
};
exports.default = RedeemSectionPsnCountryDropDown;
//# sourceMappingURL=RedeemSectionPsnCountryDropDown.js.map